module.exports = __webpack_public_path__ + "static/img/stripe-logo-blue.fb4644a0.png";